import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  float: left;
  margin-bottom: 5px;
  padding: 0 0px;

  @media (max-width: 1024px) {
  }
`;

export const Control = styled.div`
  width: 100%;
  float: left;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 50px;
  cursor: pointer;
  padding: 10px 10px;
  background: ${({ theme }) => theme.colors.LIGHT4};
  transition: all 0.5s ease;
  border-radius: 10px;

  &.enable {
    background: ${({ theme }) => theme.colors.LIGHT3};
    border-radius: 10px 10px 0 0;
  }

  @media (max-width: 1024px) {
  }
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.TEXT1};
  flex: 1;
  font-size: 14px;
  display: flex;
  align-items: center;

  i {
    margin-right: 15px;
    width: 20px;
    height: 20px;
    display: flex;
  }

  @media (max-width: 1024px) {
  }
`;

export const Right = styled.div`
  &.enable {
  }

  @media (max-width: 1024px) {
  }
`;

export const Content = styled.div`
  width: 100%;
  float: left;

  &.enable {
    padding: 15px;
    background: ${({ theme }) => theme.colors.LIGHT6};
    border-radius: 0 0 10px 10px;
  }
`;
